import React from "react";
import { useSelector } from "react-redux";
import { constants } from "@qgiv/core-js";
import { selectUserSelectedClassification } from "../../../../../../redux/slices/classificationsSlice";
import { selectCurrentForm } from "../../../../../../redux/slices/currentFormSlice";
import { selectCmsControlByType } from "../../../../../../redux/slices/cmsSettingsSlice";
import { updateTeams } from "../../../../../../redux/slices/teamsSlice";
import { setAppTeamModalOpen } from "../../../../../../redux/slices/appSettingsSlice";
import CreateTeamFooter from "./CreateTeamFooter";

const ConnectedCreateTeamFooter = () => {
    const {
        ENUMS: {
            CMS_Control: { P2P_REGISTRATION_CONTENT },
        },
    } = constants;
    const {
        hasSelectedClassification,
        selectedClassification: { teamRegistrantLimit = 0 },
    } = useSelector(selectUserSelectedClassification);

    const currentForm = useSelector(selectCurrentForm);
    const control = useSelector((state) =>
        selectCmsControlByType(P2P_REGISTRATION_CONTENT, state),
    );

    const {
        options: {
            createTeamModal: { submitButtonLabel = "Save My Team" },
        },
    } = control;

    const createTeamFooterProps = {
        formId: currentForm,
        submitButtonLabel,
        hasSelectedClassification,
        teamRegistrantLimit: hasSelectedClassification
            ? teamRegistrantLimit
            : 0,
        setAppTeamModalOpen,
        updateTeams,
    };
    return <CreateTeamFooter {...createTeamFooterProps} />;
};

export default ConnectedCreateTeamFooter;
